module.exports = __webpack_public_path__ + "img/panelView_defaultBG_special_strong_3_3.9bbfb3b4.png";